import { City } from '../model/city';
import { Place } from '../model/place';
import { Product } from '../model/product';
import { Lot } from '../model/lot';
import { ProductLocation } from '../model/product-location';
import { InfoSection } from '../model/info-section';
import { Terminal } from '../model/terminal';
import { ProductExtra } from '../model/product-extra';
import { Promo } from '../model/promo';
import { LocationBuilder } from './location-builder';
import { GeofenceInfoBuilder } from './geofence-info-builder';
import { OpeningHours } from '../model/opening-hours';
import { ProductContact } from '../model/product-contact';
import { ImageGalleryBuilder } from "./image-gallery-builder";
export class ProductBuilder {
    static buildCity(data) {
        let city = new City();
        city.id = data.city_id;
        city.name = data.name;
        city.location = LocationBuilder.buildLocation(data.location || {});
        city.places = data.places.map(place => this.buildPlace(place));
        return city;
    }
    static buildPlace(data) {
        let place = new Place();
        place.id = data.place_id;
        place.name = data.name;
        place.type = data.type;
        place.location = LocationBuilder.buildLocation(data.location || {});
        place.products = data.products.map(product => this.buildProduct(product, place));
        return place;
    }
    static buildProduct(data, place) {
        let product = new Product();
        product.id = data.product_id;
        product.name = data.product_name;
        product.provider = data.provider;
        product.service = data.service;
        product.rsysAheadHours = data.rsys_ahead_hours;
        product.openingHours = this.buildOpeningHours(data.openingHours);
        product.official_parking_name = data.official_parking_name;
        product.keys_required_sometimes = data.keys_required_sometimes;
        product.wash_default_calle = data.wash_default_calle;
        product.carencia = data.carencia;
        product.dias_sin_carencia = data.dias_sin_carencia;
        product.day_hours = data.day_hours;
        product.is_active = (data.is_active && +data.is_active === 1);
        product.only_internal = (data.only_internal && +data.only_internal === 1);
        product.basic_space_description = data.basic_space_description;
        product.basic_space_name = data.basic_space_name;
        product.place_id = data.place_id;
        product.type = data.type;
        product.specific_checkin_hours = data.specific_checkin_hours;
        product.specific_checkout_hours = data.specific_checkout_hours;
        product.offer_wash = data.offer_wash;
        product.offer_carservice = data.offer_carservice;
        let info = data.info;
        product.image_gallery = (info && info.image_gallery) ? info.image_gallery : null;
        product.icon = (info && info.icon) ? info.icon : null;
        product.shortDescription = info.short_description;
        product.location = this.buildProductLocation(info.location, place);
        product.contact = this.buildProductContact(info);
        product.serviceInfo = info.service_info ? info.service_info.map(info => this.buildInfoSection(info)) : [];
        product.terminals = info.terminals ? info.terminals.map(terminal => this.buildTerminal(terminal)) : [];
        return product;
    }
    static buildProductAdmin(data, place) {
        let product = new Product();
        product.id = data.id;
        product.idRsys1 = data.id_rsys_1;
        product.idLot = data.id_lot;
        product.carencia = data.carencia;
        product.dayHours = data.day_hours;
        product.freeTime = data.free_time;
        product.rsysAheadHours = data.rsys_ahead_hours;
        product.askPassengers = data.ask_passengers;
        product.name = data.product_name;
        product.nameShort = data.name_short;
        product.openingHoursType = data.openinghours_type;
        product.openHour = data.open_hour;
        product.openMinute = data.open_minute;
        product.closeHour = data.close_hour;
        product.closeMinute = data.close_minute;
        product.aenaDays = data.aena_days;
        product.idProvider = data.provider_id;
        product.numOptions = data.num_options;
        product.idRsys2 = data.id_rsys_2;
        product.idRsys3 = data.id_rsys_3;
        product.isActive = data.is_active;
        product.onlyInternal = data.only_internal;
        product.type = data.type;
        product.lat = data.lat;
        product.lng = data.lng;
        product.nameEs = data.name_es;
        product.nameEn = data.name_en;
        product.nameCa = data.name_ca;
        product.namefr = data.name_fr;
        product.requiredSpaceNumber = data.required_space_number;
        product.requiredStreet = data.required_calle;
        product.extras = data.extras ? data.extras.map(extra => this.buildExtra(extra)) : [];
        product.terminals = data.terminals ? data.terminals.map(terminal => this.buildTerminal(terminal)) : [];
        product.place_id = data.place_id;
        return product;
    }
    static buildLot(data) {
        let lot = new Lot();
        lot.id = data.id;
        lot.isActive = data.is_active;
        lot.name = data.name;
        lot.nameShort = data.name_short;
        lot.mark = data.mark;
        lot.companyName = data.compnay_name;
        lot.address = data.address;
        lot.city = data.city;
        lot.state = data.state;
        lot.zip = data.zip;
        lot.phone = data.phone;
        lot.email = data.email;
        lot.web = data.web;
        lot.nif = data.nif;
        lot.thanks = data.thanks;
        lot.text = data.text;
        lot.capacity = data.capacity;
        lot.askForPassengers = data.ask_for_passengers;
        lot.ship = data.ship;
        return lot;
    }
    static buildTerminal(data) {
        let terminal = new Terminal();
        terminal.id = data.terminal_id;
        terminal.common_terminal_id = data.common_terminal_id;
        terminal.name = data.name;
        terminal.name_short = data.name_short;
        terminal.dynamic_premiumRequestAnticipationTime = data.premium_request_anticipation_time;
        terminal.minutes_distance_to_terminal = data.minutes_distance_to_terminal;
        let checkIn = data['check-in'];
        if (checkIn) {
            terminal.checkInLocation = LocationBuilder.buildLocation(checkIn.location);
            terminal.checkInInstructions = checkIn.instructions ? checkIn.instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.checkInFinalInstructions = checkIn.final_instructions ? checkIn.final_instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.checkInPremiumRequestedInstructions = checkIn.premium_requested_instructions ? checkIn.premium_requested_instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.checkInInfo = checkIn.info ? checkIn.info.map(i => this.buildInfoSection(i)) : [];
            terminal.printInstructions = checkIn.print_instructions ? checkIn.print_instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.printInfo = checkIn.print_info ? checkIn.print_info.map(i => this.buildInfoSection(i)) : [];
            terminal.checkInAgentGeofencesInfo = checkIn.location ? ProductBuilder.buildGeofence(checkIn.location.agent_geofences) : [];
            terminal.checkInClientGeofencesInfo = checkIn.location ? ProductBuilder.buildGeofence(checkIn.location.client_geofences) : [];
        }
        let checkOut = data['check-out'];
        if (checkOut) {
            terminal.checkOutLocation = LocationBuilder.buildLocation(checkOut.location);
            terminal.checkOutInstructions = checkOut.instructions ? checkOut.instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.checkOutFinalInstructions = checkOut.final_instructions ? checkOut.final_instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.checkOutPremiumRequestedInstructions = checkOut.premium_requested_instructions ? checkOut.premium_requested_instructions.map(i => this.buildInfoSection(i)) : [];
            terminal.checkOutInfo = checkOut.info ? checkOut.info.map(i => this.buildInfoSection(i)) : [];
            terminal.checkOutAgentGeofencesInfo = checkOut.location ? ProductBuilder.buildGeofence(checkOut.location.agent_geofences) : [];
            terminal.checkOutClientGeofencesInfo = checkOut.location ? ProductBuilder.buildGeofence(checkOut.location.client_geofences) : [];
        }
        return terminal;
    }
    static buildGeofence(data) {
        let geofences = [];
        if (data) {
            data.forEach((i) => {
                let geofence = GeofenceInfoBuilder.buildGeofenceInfo(i);
                if (geofence) {
                    geofences.push(geofence);
                }
            });
        }
        return geofences;
    }
    static buildExtra(data) {
        let extra = new ProductExtra();
        if (!data) {
            return null;
        }
        extra.id = data.extra_id;
        extra.name = data.name;
        extra.name_es = data.name_es;
        extra.name_ca = data.name_ca;
        extra.name_en = data.name_en;
        extra.name_fr = data.name_fr;
        extra.description = data.description;
        extra.long_description = data.long_description;
        extra.type = data.type;
        extra.icon = data.icon;
        extra.image_gallery = data.image_gallery ? ImageGalleryBuilder.buildImageGallery(data.image_gallery) : null;
        extra.keys_needed = Boolean(data.keys_needed);
        extra.unitaryPrice = data.unitary_price;
        extra.priceCalculationMode = data.price_calculation;
        extra.price = data.price;
        extra.public = Boolean(data.public);
        extra.service_type = data.service_type;
        extra.send_desinfection_seal = data.send_desinfection_seal;
        extra.availability_status = data.availability_status;
        return extra;
    }
    static buildPromo(data) {
        let promo = new Promo();
        if (!data) {
            return promo;
        }
        promo.id = data.promo_id;
        promo.name = data.promo_name;
        promo.code = data.promo_code;
        promo.discount = data.discount;
        promo.discount_euro = data.discount_euro;
        promo.error = data.error;
        return promo;
    }
    static buildProductLocation(data, place) {
        let location = new ProductLocation(data.lat, data.lng);
        if (!data) {
            return location;
        }
        location.city = data.city && data.city.name;
        location.placeName = place && place.name;
        location.placeType = place && place.type;
        return location;
    }
    static buildInfoSection(data) {
        let infoSection = new InfoSection();
        if (!data) {
            return null;
        }
        infoSection.icon = data.icon;
        infoSection.name = data.name;
        infoSection.body = data.body;
        infoSection.image = data.image;
        infoSection.videoUrl = data.videoUrl;
        infoSection.type = data.type;
        infoSection.mapUrl = data.mapUrl;
        infoSection.shuttleInfo = data.shuttleInfo;
        infoSection.barcode = data.barcode;
        infoSection.secondaryStyle = data.secondaryStyle;
        infoSection.noCollapsable = data.noCollapsable;
        infoSection.unfolded = data.unfolded;
        infoSection.dynamicContent = data.dynamicContent;
        return infoSection;
    }
    static buildOpeningHours(data) {
        let openingHours = new OpeningHours();
        if (!data) {
            return null;
        }
        openingHours.type = data.type;
        openingHours.open = data.open;
        openingHours.close = data.close;
        return openingHours;
    }
    static buildProductContact(data) {
        const productContact = new ProductContact();
        if (!data) {
            return null;
        }
        productContact.email = data.contact_email;
        productContact.phone = data.contact_phone;
        productContact.address = data.product_address;
        return productContact;
    }
}
//# sourceMappingURL=product-builder.js.map